export enum SolutionValueChanged {
    MasterGain = 0,
    BandEqualizer = 1,
    Both = 2,
}
